import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.DeiCategory2EnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    deiCategory2EnumList: { items: data, total },
  } = await sdk.getListDeiCategory2Enum(filterSortPage({ sort, pagination }));

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { deiCategory2Enum: data } = await sdk.getOneDeiCategory2Enum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { deiCategory2EnumMany: data } = await sdk.getManyDeiCategory2Enum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const deiCategory2Enum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
